import { dataChevronRightCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconChevronRightCircleSolid = /*#__PURE__*/createIcon(dataChevronRightCircleSolid)
export default IconChevronRightCircleSolid
